import * as React from "react";
import type { SVGProps } from "react";
const SvgPlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="plus_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M554.667 213.333a42.667 42.667 0 1 0-85.334 0v256h-256a42.667 42.667 0 1 0 0 85.334h256v256a42.667 42.667 0 1 0 85.334 0v-256h256a42.667 42.667 0 1 0 0-85.334h-256v-256z"
    />
  </svg>
);
export default SvgPlusIcon;
